<template>
    <div>
        <div class="message button-message">
            <div class="bot-response button">
                <div class="button-content">
                    <div class="button-description" v-html="messageText(data.raw.payload.message)" />
                </div>
            </div>
        </div>
        <div class="buttons">
            <div
                class="single-button"
                :class="{ disabled }"
                v-for="(button, i) in data.raw.payload.buttons"
                :key="button.id"
                @click="
                        sendButtonMessage('BUTTON', {
                            buttonId: button.id,
                            blockId: data.raw.payload.blockId,
                            payloadId: data.raw.payload.id,
                            uniqMessageId: data.raw.uniqMessageId,
                            buttonPayload: button.payload,
                        })
                    "
            >
                <div class="single-button-text" v-html="button.title"/>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import { mapState } from "vuex";
import { htmlUnescape } from "escape-goat";
import Autolinker from "autolinker";

export default {
    name: "BotButtonMessage",
    props: ["data", "disabled"],
    computed: {
        ...mapState({
            siteId: (state) => _.get(state.site.site, "_id"),
        }),
    },
    data() {
        return {
            clickedButton: null,
        };
    },
    methods: {
        messageText(message) {
            let escaped = htmlUnescape(message.trim());

            let res = Autolinker.link(escaped, {
                className: "chatLink",
                truncate: { length: 50, location: "smart" },
            });
            res = this.createLinkHTML(res);
            res = res.replace(/<p>&nbsp;<\/p>$/gi, "");
            return res;
        },
        createLinkHTML(str) {
            let parser = new DOMParser();
            let virtualDom = parser.parseFromString(str, "text/html");
            virtualDom.querySelectorAll("a").forEach((a) => {
                a.setAttribute("target", "_blank");
            });
            return virtualDom.body.innerHTML;
        },
        sendButtonMessage(type, payload) {
            if (this.disabled) return;
            this.clickedButton = payload.buttonId;
            sendSocketMessage("chatbot/v2 user-button-select", {
                siteId: this.siteId,
                conversationId:
                    this.data.raw.conversationId ||
                    _.get(this.data.raw.conversation, "_id", this.data.raw.conversation),
                type,
                payload,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.message.button-message {
    border: 1px solid;
    border-radius: 10px;
    overflow: hidden;
    width: 240px;
    border-color: rgb(219, 225, 232);
    background: rgb(255, 255, 255);

    .button-content {
        display: flex;
        flex-direction: column;
        padding: 0 20px 30px;

        .button-description {
            word-wrap: break-word;
            font-size: 16px;
            line-height: 20px;
            margin-top: 12px;
            white-space: pre-wrap;
            color: rgb(0, 0, 0);
        }
    }
}
.buttons {
    display: flex;
    flex-direction: column;
    width: 100%;

    .single-button {
        align-items: center;
        border-top: 1px solid;
        cursor: pointer;
        display: flex;
        font-weight: 600;
        height: 45px;
        padding: 0 10px;
        transition: all 0.3s;
        background: var(--chatbot-button-color) !important;
        border: 1px solid var(--chatbot-button-text-color) !important;
        margin: 4px;
        border-radius: 5px;

        &:hover {
            opacity: 0.8 !important;
            transform: scale(1.05);
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        }

        &.disabled {
            opacity: 0.5 !important;
            cursor: not-allowed;
        }

        .single-button-text {
            overflow: hidden !important;
            text-align: center;
            //text-overflow: ellipsis;
            //white-space: nowrap;
            width: 100%;
            color: var(--chatbot-button-text-color) !important;
            font-size: 12px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/chatbot/BotButtonMessage.vue